import React, { useEffect, useState } from "react"
import Modal from "../../components/Modal"
import Loading from "../layouts/Loading"
import api from "../../services/api"
import styles from "./outboundCampaignList.module.css"

const stages = [
    { id: "total", label: "Contatos" },
    { id: "sent", label: "Enviadas" },
    { id: "delivered", label: "Entregues" },
    { id: "read", label: "Lidas" },
    { id: "replied", label: "Respostas" },
]

const CampaignComparisonModal = ({ campaignIds, closeModal }) => {
    const [campaigns, setCampaigns] = useState([])
    const [error, setError] = useState("")

    useEffect(() => {
        const params = new URLSearchParams()
        campaignIds.forEach(id => params.append("campaign_ids", id))
        api.get(`/outbound-campaigns/compare?${params.toString()}`)
            .then(response => setCampaigns(response.data?.data || []))
            .catch(err => setError(err?.response?.data?.message || "Não foi possível comparar as campanhas."))
    }, [campaignIds])

    return (
        <Modal title="Comparar campanhas" description="Resultados e conversão entre etapas" closeModal={closeModal} fullWidith>
            {!campaigns.length && !error && <Loading />}
            {error && <div className={styles.comparisonError}>{error}</div>}
            {campaigns.length > 0 && (
                <div className={styles.comparisonGrid}>
                    {campaigns.map(campaign => (
                        <article key={campaign._id} className={styles.comparisonCard}>
                            <div className={styles.comparisonHeader}>
                                <strong>{campaign.name}</strong>
                                <span>{campaign.delivery_rate}% entrega · {campaign.reply_rate}% resposta</span>
                            </div>
                            <div className={styles.comparisonFunnel}>
                                {stages.map((stage, index) => {
                                    const value = Number(campaign[stage.id] || 0)
                                    const previous = index ? Number(campaign[stages[index - 1].id] || 0) : value
                                    const rate = previous ? Math.round(value / previous * 100) : 0
                                    return (
                                        <div key={stage.id} style={{ width: `${Math.max(34, 100 - index * 12)}%` }}>
                                            <span>{stage.label}</span><strong>{value}</strong>{index > 0 && <small>{rate}%</small>}
                                        </div>
                                    )
                                })}
                            </div>
                            <div className={styles.comparisonRates}>
                                <span>Leitura <strong>{campaign.read_rate}%</strong></span>
                                <span>Falhas <strong>{campaign.failure_rate}%</strong></span>
                            </div>
                        </article>
                    ))}
                </div>
            )}
        </Modal>
    )
}

export default CampaignComparisonModal
